/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/saveItpLibraryEntry.ts
 * FILE_ID: JOBHUB-QA-ITP-LIBRARY-SAVE-001
 * PURPOSE: Store the current ITP HTML under a name.
 */
import type { QaApi } from '../../qa/qaApi'
import type { QaItpRequest } from './qaItpScope'

export async function saveItpLibraryEntry(
  api: Pick<QaApi, 'createItpLibraryEntry'>,
  input: {
    inspectionId: string
    name: string
    html: string
    request: QaItpRequest
  },
) {
  const name = input.name.trim()
  if (!name) throw new Error('Enter a name.')
  if (input.request.areaIds.length === 0) throw new Error('Select checks, a checklist, or an area first.')
  // Reused from: packages/job-hub/src/jobs/qa/itpDocument.ts (buildItpRequestHtml) at the call site that builds html.
  return api.createItpLibraryEntry({
    inspection_id: input.inspectionId,
    name,
    html: input.html,
    area_ids: input.request.areaIds,
    checklist_ids: input.request.checklistIds ?? [],
    item_ids: input.request.itemIds ?? [],
  })
}
